import { PaymentStatus } from '@/shared/enums/PaymentStatus'
import { SubscriptionStatus } from '@/shared/enums/SubscriptionStatus'
import CheckoutForm from '../../models/CheckoutForm'
import CheckoutSuccess from '../../models/CheckoutSuccess'
import checkoutApi from '../api/checkout.api'

class CheckoutService {
  async post(checkoutForm: CheckoutForm, attemptReference?: string, useExternal3ds?: boolean): Promise<CheckoutSuccess> {
    try {
      const payload = checkoutForm.toServer(attemptReference, useExternal3ds)
      const { data } = await checkoutApi.post(payload)

      return new CheckoutSuccess(data)
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  async transactionStatus(id: string): Promise<PaymentStatus | undefined> {
    try {
      const { data } = await checkoutApi.transactionStatus(id)
      return data.transaction_status
    } catch (error) {
      console.error(error)
      return undefined
    }
  }

  async subscriptionStatus(id: string): Promise<SubscriptionStatus | undefined> {
    try {
      const { data } = await checkoutApi.subscriptionStatus(id)
      return data.subscription_status
    } catch (error) {
      console.error(error)
      return undefined
    }
  }

  async bankTransferList(contractId: string, country: string) {
    try {
      const { data } = await checkoutApi.bankTransferList(contractId, country)
      return data
    } catch (error) {
      console.error(error)
      return undefined
    }
  }

  async getMethods(checkoutId: string): Promise<CheckoutSuccess> {
    try {
      const { data } = await checkoutApi.getMethods(checkoutId)
      return new CheckoutSuccess(data)
    } catch (error) {
      console.error(error)
      throw error
    }
  }

}

export default new CheckoutService()
